import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import NotifyCartAboutTrackingDeleteCheckbox from '../../../common/components/Order/NotifyCartAboutTrackingDeleteCheckbox.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {deleteLabel} from '../../../data/orders.js'
import {refreshOrderList} from '../orderListActions.js'
import {LABEL_TYPE_SHIPPING} from '../../../common/constants/LabelConfig.js'

export const MODAL_FORM = 'confirm_label_delete_modal_form'

export function showConfirmLabelDeleteModal(orderNumber, labelType) {
  setForm(MODAL_FORM, {
    orderNumber,
    labelType,
    isSaving: false,
    serverError: null,
    notifyCart: false,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  const forms = formsSelector(state)
  return forms[MODAL_FORM]
}

export async function confirm() {
  try {
    const {orderNumber, labelType, notifyCart} = modalFormSelector(getState())

    updateModalForm({isSaving: true, serverError: null})

    await deleteLabel(orderNumber, labelType, notifyCart)

    showMessageToast('Label was successfully deleted.')

    closeModal()

    refreshOrderList()
  } catch (err) {
    updateModalForm({
      serverError: `Error deleting label: ${err.message || err.error_message}`,
      isSaving: false,
    })
  }
}

function ConfirmLabelDeleteModal({form}) {
  const labelName =
    form.labelType === LABEL_TYPE_SHIPPING ? 'Shipping' : 'Return'

  return (
    <ConfirmModal
      title={`Delete ${labelName} Label`}
      onConfirm={() => confirm()}
      onCancel={() => closeModal()}
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <p className="fs-01 lh-md margin-bottom-0">
        <strong>Are you sure you want to delete this label?</strong>
      </p>
      <NotifyCartAboutTrackingDeleteCheckbox
        orderNumbers={[form.orderNumber]}
        labelType={form.labelType}
        checked={form.notifyCart}
        onChange={() => updateModalForm({notifyCart: !form.notifyCart})}
      />
    </ConfirmModal>
  )
}

export default onlyIfForm(ConfirmLabelDeleteModal, modalFormSelector)
